import { normalizeDocument } from './document';

export const isValidCNPJ = (cnpj = '') => {
  cnpj = normalizeDocument(cnpj);

  if (cnpj.length !== 14 || /^([A-Z0-9])\1+$/.test(cnpj)) {
    return false;
  }

  const weightsFirstCheck = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const weightsSecondCheck = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  let sum = 0;

  for (const [i, weight] of weightsFirstCheck.entries()) {
    const value = cnpj.charCodeAt(i) - 48;
    sum += value * weight;
  }

  let firstCheckDigit = sum % 11;
  firstCheckDigit = firstCheckDigit < 2 ? 0 : 11 - firstCheckDigit;

  if (firstCheckDigit !== parseInt(cnpj.charAt(12))) {
    return false;
  }

  sum = 0;

  for (const [i, weight] of weightsSecondCheck.entries()) {
    const value = cnpj.charCodeAt(i) - 48;
    sum += value * weight;
  }

  let secondCheckDigit = sum % 11;
  secondCheckDigit = secondCheckDigit < 2 ? 0 : 11 - secondCheckDigit;

  if (secondCheckDigit !== parseInt(cnpj.charAt(13))) {
    return false;
  }

  return true;
};
